/* eslint-disable fp/no-mutation */
import httpClient, { AxiosResponse } from 'axios'
import { getTokens } from './auth0Client' // Adjust the import path as necessary

httpClient.interceptors.request.use(
  async (request) => {
    if (
      !request.url?.includes('/register') &&
      !request.url?.includes('/external-survey') &&
      !request.url?.includes('/api/subscription/user') &&
      // !request.url?.includes('/api/promo/validate') &&
      request.url?.indexOf('/api') === 0
    ) {
      let { accessToken } = await getTokens()
      if (accessToken) {
        request.headers.Authorization = `Bearer ${accessToken}`
      }
    }

    if (request.url?.indexOf('/api') === 0) {
      request.url = `${import.meta.env.VITE_BACKEND_URL}${request.url}`
    }

    return request
  },
  (error) => Promise.reject(error),
)

httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.toString()?.includes('status code 401')) {
      localStorage.removeItem('jwt') // This line may become redundant if using the Auth0 client to manage tokens
      if (
        !window.location.pathname.includes('/reset-password') &&
        !window.location.pathname.includes('/request-reset-password') &&
        !window.location.pathname.includes('/register') &&
        !window.location.pathname.includes('/boundtree') &&
        !window.location.pathname.includes('/boundtree-trial') &&
        !window.location.pathname.includes('/boundtree-login') &&
        !window.location.pathname.includes('/complete-registration') &&
        !window.location.pathname.includes('/subscribe') &&
        !window.location.pathname.includes('/subscribe-boundtree') &&
        !window.location.pathname.includes('/external-survey')
      ) {
        window.location.href = '/'
      }
    }
    return Promise.reject(error)
  },
)

export let pluckData = <T>(response: AxiosResponse<T>) => response.data

export default httpClient
